import { useEffect, useState } from 'react'
import { LoaderIcon } from 'react-hot-toast'
import { useStore } from "../../store/store"

interface PdfProps {
    name: string
    toolbar?: number
    navpanes?: number
    scrollbar?: number
}

export const Pdf = ({ name, toolbar, navpanes, scrollbar }: PdfProps) => {
    const language = useStore(state => state.language);

    const documentLinks = {
      terms_of_use: 'https://drive.google.com/file/d/1mlM4_s5KaThnz8wDsCKLms_8dRnO4xtekcjdn0bfBiY/preview'
    }

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 764);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div style={{ width: "100%", height: "100vh" }}>
            {isLoading && <LoaderIcon style={{ scale: 2 }} /> }
            <iframe
                width="100%"
                height="95%"
                style={{ border: "none", backgroundColor: "transparent", visibility: isLoading ? "hidden" : "visible" }}
                src={documentLinks[name as keyof typeof documentLinks]}>
        </iframe>
        </div>
    );
};
